import React, { useEffect, useState} from "react";

import styled from "styled-components";
// import { getPopmenuInfo } from '@/api/base'
import Header from "@/components/Header";
import bridge from "@/config/JSbridge";
import smoothscroll from "smoothscroll-polyfill";
import bwmodel from "@/config/bwmodel";

// import ModalView from '@/components/modal-view'
import OpenApp from "../../components/OpenApp";
import { connect } from "react-redux";
import h5Share from "@/utils/h5Share";
import { handleUploadTrace, jumpTo } from "@/utils";

const Active_149 = ({ token }) => {
  const active_id = 149;
  // const [showAddr,setShowAddr] = useState(false);
  const isStorm = bwmodel.app === "storm";
  
  const [activeIndex, setActiveIndex] = useState(0);
  const navItems = [

    {
      title: '特色功能',
      subItems: [
        { title: '选股分析', anchorId: 'product1' },
        { title: '投资分析', anchorId: 'product2' },
        { title: '投资交流', anchorId: 'product3' }
      ]
    },
    {
      title: '股神历练',
      subItems: [
        { title: '模拟炒股', anchorId: 'service1' },
      ]
    },
    {
      title: '功能教学',
      subItems: [
        { title: '会员功能', anchorId: 'service2' }
      ]
    }
  ];
  const handleScroll = (anchorId) => {
    // const element = document.getElementById(anchorId);
    const targetElement = document.getElementById(anchorId);
    console.log(targetElement);
    
    const targetRect = targetElement.getBoundingClientRect();
    
    // 垂直滚动到目标元素的位置
    window.scrollTo({
      top: targetRect.top + window.pageYOffset - 120,
      behavior: "smooth"
    });
    // if (element) {
    //   element.scrollIntoView({
    //     behavior: 'smooth',
    //     block: 'start'
    //   });
    // }
    setTimeout(() => {
      setActiveIndex(null)
    }, 300);
    // setActiveIndex(null)
  };

  useEffect(() => {
    document.title = "投资学院";
   
    handleUploadTrace('Beginner_Home_Exposure', 'visitor')
    h5Share.main({
      title: `新同学必看【一遇风云便化龙】`,
      desc: "风云君来给未来的股神们送福利啦！一眼查找特色功能！",
      link: process.env.REACT_APP_DEMAND_URL + "active_" + active_id,
      thumbUrl: "https://file.wogoo.com/app/logo/logo6.png",
      wxShare: {
        shareData: {
          imgUrl: "https://file.wogoo.com/app/logo/logo6.png",
        },
      },
      shareData: {
        imgUrl: "https://file.wogoo.com/app/logo/logo6.png",
      },
    });
    smoothscroll.polyfill();

    // getData();
  }, []);

  const handleLeftClick = () => {
    bridge.callHandler(
      "nativeEvent",
      {
        event: "close",
        params: {
          isDelete: false,
        },
      },
      () => {}
    );
  };


  return (
    <div>
      {isStorm && (
        <Header
          title={"投资学院"}
          leftClick={() => {
            handleLeftClick();
          }}
          hideNaviBar
          right={
            bwmodel.compareVersion("4.17.9") ? (
              <img
                onClick={() => {
                  bridge.callHandler("nativeEvent", {
                    event: "shareLink",
                    params: {
                      // shareLinkParams:{
                      title: `新同学必看【一遇风云便化龙】`,
                      desc: "风云君来给未来的股神们送福利啦！一眼查找特色功能！",
                      thumbUrl: "https://file.wogoo.com/app/logo/logo6.png",
                      linkUrl: process.env.REACT_APP_DEMAND_URL + "active_149",
                    },
                  });
                }}
                style={{ width: "20px", "vertical-align": "middle" }}
                src={
                  bwmodel.theme === "0"
                    ? require(`@/img/share.png`)
                    : require(`@/img/share_dark.png`)
                }
                alt="分享"
              />
            ) : (
              ""
            )
          }
        />
      )}

      <Container style={{ marginTop: isStorm ? "44px" : "0px" }}>
        <div className="header-container">
          <img
            className="member-img"
            src={require("./img/Slice5@2x.png")}
            alt="热点脉冲"
          />
          <img
            onClick={()=>{
              handleUploadTrace('Beginner_Group_Chat_Click', 'click')
              jumpTo('storm://app/chat/userGroupChatList?userId=bb7e0b73a4cd4693b12845fbcd4d67d0')
            }}
            className="group-btn"
            src={require("./img/Slice1@2x.png")}
            alt="新手群聊"
          />
          {/* <img className="gift-btn" src={require("./img/新人福利@2x.png")} alt="热点脉冲" /> */}
        </div>
        {/* <img src={require("./img/Slice4@2x.png")} alt="热点脉冲" /> */}

      <nav className="navigation" style={{ top: isStorm ? "44px" : "0px" }}>
      <ul className="main-nav">
        {navItems.map((item, index) => (
          <li
            key={item.title}
            className="nav-item"
            onClick={()=>{
              setActiveIndex(index)
            }}
            onMouseEnter={() => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(null)}
          >
            <span className="nav-link">
              <img src={require("./img/1.png")} alt="投资学院" />
              <span>{item.title}</span>
              <img className="arrow"  src={require("./img/箭头.png")} alt="热点脉冲" />
            </span>
            {/* {item.subItems} */}
            {/* <ul className="sub-nav">
                {item.subItems.map((subItem) => (
                  <li key={subItem.anchorId} className="sub-nav-item">
                    <button
                      className="sub-nav-link"
                      onClick={() => handleScroll(subItem.anchorId)}
                    >
                      {subItem.title}
                    </button>
                  </li>
                ))}
              </ul> */}
            {item.subItems && activeIndex === index && (
              <ul className="sub-nav">
                {item.subItems.map((subItem) => (
                  <li key={subItem.anchorId} className="sub-nav-item">
                    <button
                      className="sub-nav-link"
                      onClick={() => handleScroll(subItem.anchorId)}
                    >
                      {subItem.title}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>

       
        {/* <img className="member-img" src={require('./img/Slice1@2x.png')} alt="热点脉冲" /> */}
        <div className="card-box">
          <img
            className="title-img"
            src={require("./img/入门礼包@2x.png")}
            alt="入门礼包"
          />
          <div className="content">
            <div className="member-content member-content3">
              <img
                onClick={() => {
                  jumpTo(
                    "https://s.wogoo.com/4RHyLZ"
                  );
                }}
                className="member-img"
                src={require("./img/Slice6@2x.png")}
                alt="热点脉冲"
              />
              <img
                onClick={() => {
                  jumpTo(
                    "https://www.wogoo.com/essay/#/?articleId=df300959fcba49e3ab5b4b038836b206&articleType=1"
                  );
                }}
                src={require("./img/Slice7@2x.png")}
                alt="热点脉冲"
              />
              <img
                onClick={() => {
                  jumpTo(
                    "https://s.wogoo.com/1aydWl"
                  );
                }}
                src={require("./img/Slice8@2x.png")}
                alt="热点脉冲"
              />
            </div>
          </div>
        </div>

        <div className="card-box">
          <img
            className="title-img"
            src={require("./img/特色功能@2x.png")}
            alt="特色功能"
          />
          <div className="content">
            <div className="title2" id="product1">
              <img src={require("./img/Slice11@2x.png")} alt="选股分析" />
            </div>

            <div className="member-content">
              <img
                onClick={() => {
                  jumpTo("storm://app/marketQuotations/patternStockList");
                }}
                src={require("./img/Slice12@2x.png")}
                alt="形态选股"
              />
              <img
                onClick={() => {
                  jumpTo("storm://app/marketQuotations/stockPicker");
                }}
                src={require("./img/Slice13@2x.png")}
                alt="策略广场"
              />
              <img
                onClick={() => {
                  jumpTo("storm://app/sns?subTabName=shortTerm");
                }}
                src={require("./img/Slice14@2x.png")}
                alt="短线挖掘"
              />
              <img
                onClick={() => {
                  jumpTo(
                    "storm://app/marketQuotations/riskRadar?index=1&isAppNeedLogin=1"
                  );
                }}
                src={require("./img/Slice15@2x.png")}
                alt="风险雷达"
              />
            </div>

            <div className="title2"  id="product2">
              <img src={require("./img/标@2x.png")} alt="投资分析" />
            </div>

            <div className="member-content">
              <img
                onClick={() => {
                  jumpTo(
                    "storm://app/topic/detail?topicId=5bae4017d4a84e1cba0bed00a027eca3"
                  );
                }}
                src={require("./img/Slice16@2x.png")}
                alt="涨停分析"
              />
              <img
                onClick={() => {
                  jumpTo(
                    "storm://app/topic/detail?topicId=efa56650cd9d45ecb067d4f3c960638f"
                  );
                }}
                src={require("./img/Slice17@2x.png")}
                alt="吾股涨停复盘"
              />
              <img
                onClick={() => {
                  jumpTo("https://data.wogoo.com/rankV2.0/#/stockPage");
                }}
                src={require("./img/Slice18@2x.png")}
                alt="每日行情复盘"
              />
              <img
                onClick={() => {
                  jumpTo("storm://app/marketQuotations/limitUp");
                }}
                src={require("./img/Slice19@2x.png")}
                alt="连板梯队"
              />
              <img
                onClick={() => {
                  jumpTo(
                    "storm://app/webview?url=aHR0cHM6Ly9mMTAud29nb28uY29tLyMvc3ViamVjdA==&isAppNeedLogin=1"
                  );
                }}
                src={require("./img/Slice21@2x.png")}
                alt="题材宝典"
              />
              <img
                onClick={() => {
                  jumpTo(
                    "https://www.wogoo.com/essay/#/community?momentsId=63e4608c3a14445dbe6ad99f50b55368"
                  );
                }}
                src={require("./img/Slice22@2x.png")}
                alt="AI助手"
              />
              <img
                onClick={() => {
                  jumpTo("storm://app/homePage?subTabName=stock_rate");
                }}
                src={require("./img/Slice23@2x.png")}
                alt="风云评级	 公司好不好，搜一搜排名就知道 "
              />
              <img
                onClick={() => {
                  jumpTo("storm://app/marketQuotations/dragonRank");
                }}
                src={require("./img/Slice24@2x.png")}
                alt="龙虎榜"
              />
              <img
                onClick={() => {
                  jumpTo("https://f10.wogoo.com/#/market-manage");
                }}
                src={require("./img/Slice25@2x.png")}
                alt="市值管理"
              />
              <img
                onClick={() => {
                  jumpTo("storm://app/marketQuotations/wogooReplay");
                }}
                src={require("./img/Slice26@2x.png")}
                alt="wu 吾股精选"
              />
            </div>
            <div className="title2"  id="product3">
              <img src={require("./img/标@2x(1).png")} alt="投资交流" />
            </div>
            <div className="member-content">
              <img
                onClick={() => {
                  jumpTo("storm://app/sns");
                }}
                src={require("./img/Slice27@2x.png")}
                alt="风云社区"
              />
              <img
                onClick={() => {
                  jumpTo("https://f10.wogoo.com/#/live-more");
                }}
                src={require("./img/Slice28@2x.png")}
                alt="风云直播"
              />
              <img
                onClick={() => {
                  jumpTo("storm://app/chat/groupChatSquare");
                }}
                src={require("./img/Slice29@2x.png")}
                alt="风云群聊"
              />
              <img
                onClick={() => {
                  jumpTo("storm://app/specialColumn");
                }}
                src={require("./img/Slice30@2x.png")}
                alt="风云研报"
              />
            </div>
          </div>
        </div>

        <div className="card-box">
          <img
            className="title-img"
            src={require("./img/股神历练@2x.png")}
            alt="股神历练"
          />
          <div className="content">
            <div className="title2" id="service1">
              <img src={require("./img/标@2x(2).png")} alt="模拟炒股" />
            </div>
            <div className="member-content">
              <img
                onClick={() => {
                  jumpTo("storm://app/marketQuotations/klineCamp");
                }}
                src={require("./img/Slice31@2x.png")}
                alt="K线"
              />
              <img
                onClick={() => {
                  jumpTo("storm://app/user/combinationList");
                }}
                src={require("./img/Slice32@2x.png")}
                alt="组合炒股"
              />
            </div>
          </div>
        </div>
        <div className="card-box">
          <img
            className="title-img"
            src={require("./img/功能教学@2x.png")}
            alt="功能教学"
          />
          <div className="content">
            <div className="title2" id="service2">
              <img src={require("./img/标@2x(3).png")} alt="会员功能" />
            </div>
            <div className="member-content member-content1">
              <img
                onClick={() => {
                  jumpTo(
                    "https://s.wogoo.com/1cKhy6"
                  );
                }}
                src={require("./img/Slice33@2x.png")}
                alt="指标讲解"
              />
            </div>
          </div>
        </div>

        <div className="footer footer-freeclass-block" id="footer">
          <div
            className="btn"
            onClick={() => {
              jumpTo("storm://app/marketQuotations?subTabName=user_stock");
            }}
          >
            <img
                onClick={() => {
                  handleUploadTrace('Beginner_ Beginner_Create_Click_Click', 'click')
                  jumpTo(
                    "https://www.wogoo.com/essay/#/?articleId=e379904541074352bd8a2e576338d061"
                  );
                }}
                src={require("./img/1111.png")}
                alt="开启投资"
              />
            {/* <div>开启投资</div> */}
          </div>
        </div>
      </Container>

      {!isStorm && (
        <OpenApp
          bottom="80"
          url={`${process.env.REACT_APP_DEMAND_URL}active_149`}
        ></OpenApp>
      )}
    </div>
  );
};

const Container = styled.div`
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
  background: #da3b32;
  padding-bottom: 32vw;
  
  img {
    vertical-align: middle;
    font-size: 0;
    width: 100%;
  }
  .header-container {
    position: relative;
    padding-bottom: 69px;
    .gift-btn {
      position: absolute;
      right: 15px;
      bottom: 5px;
      width: 87px;
      // animation: pulse 1s infinite; /* 无限循环动画 */
      // animation-delay: 0.5s;
    }
    .group-btn {
      position: absolute;
      left: 15px;
      bottom: 25px;
      width: 127px;
      animation: pulse 1s infinite; /* 无限循环动画 */

    }
  }
  .navigation {
    top: 44px; /* 触发固定的阈值：当元素距离视口顶部 20px 时固定 */
    left: 0px;
    margin-left: 10px;
    margin-right: 10px;
    position: sticky;
    z-index: 99;
    margin-bottom: 10px;
  }
  .main-nav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 0.5rem;
    background: #da3b32;
    padding: 10px;
    color: #271107;
    z-index: 999;
    display: flex;
    height: 44px;
    background: linear-gradient(to right, #FDDD89, #FEF1CC);
    box-sizing: border-box;
    text-align: center;
    border-radius: 22px;
    font-weight: 700;
  }

.nav-item {
  position: relative;
  display: flex;
  alin-items: center;
}

.nav-link {
  text-decoration: none;
   img {
      width: 28px;
    }
    span {
      margin-left: 4px;
      margin-right: 6px;
      font-size: 14px;
    }
    .arrow {
      width: 10px;
    }
}

.sub-nav {
  width: 100px;
  position: absolute;
  z-index: 50;
  box-sizing: border-box;
  padding: 12px;
  background: rgba(255, 243, 209, 0.5);
  border-radius: 0px 0px 8px 8px;
  display: none;
  top: 30px;
  .sub-nav-item {
    width: 76px;
    height: 20px;
    background: #FCCB48;
    background: linear-gradient(145deg, #ffe298, #fff9ea);
    text-align: center;
    border-radius: 10px;
    line-height: 20px;
    font-size: 10px;
    font-weight: 700;
    text-align: center;
    +.sub-nav-item {
      margin-top: 6px;
    }
  }
}

.nav-item:hover .sub-nav {
  display: block;
}

.sub-nav-item {
  padding: 0.25rem 0;
}

.sub-nav-link {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  // padding: 0.5rem;
  width: 100%;
}

.sub-nav-link:hover {
  // background: #f8f9fa;
}

  .navs {
    position: sticky;
    top: 0px;
    left: 0px;
    margin-left: 10px;
    margin-right: 10px;
     position: sticky;
   
  }
  .nav {
    flex: 1;
    position: relative;
  }
  .nav-title {
    display: flex;
    align-items: center;
    img {
      width: 28px;
    }
    span {
      margin-left: 4px;
      margin-right: 6px;
      font-size: 14px;
    }
    .arrow {
      width: 10px;
    }
  }
  .nav-box{
    width: 100px;
    position: absolute;
    box-sizing: border-box;
    padding: 12px;
    background: #FFF3D1;
    border-radius: 0px 0px 8px 8px;
    display: none;
    .nav-item {
      width: 76px;
      height: 20px;
      background: #FCCB48;
      background: linear-gradient(145deg, #ffe298, #fff9ea);
      text-align: center;
      border-radius: 10px;
      line-height: 20px;
      font-size: 10px;
      font-weight: 700;
      +.nav-item {
        margin-top: 6px;
      }
    }
  }
  .member-img {
    box-sizing: border-box;
  }
  .card-box {
    margin-top: 22px;
    padding: 0 16px;
    + .card-box {
      margin-top: 22px;
    }
    .title-img {
      margin-bottom: -5.7vw;
      z-index: 1;
    }
    .content {
      background: #fff;
      padding: 2px 0px 20px;
      border-radius: 5.4vw;
      position: relative;
      z-index: 10;
    }
    .member-content {
      padding: 0 10px;

      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 7px;
    }
    .member-content3 {
      padding-top: 18px;
      grid-template-columns: 1fr 1fr 1fr;
    }
    .member-content1 {
      grid-template-columns: 1fr;
    }
    .title2 {
      margin-top: 19px;
      margin-bottom: 19px;
      background: linear-gradient(145deg, #ffe298, #fff9ea);
    }
  }

  .footer {
    height: 19vw;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
    padding: 10px 4.1vw 0px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: -126px;

    z-index: 10;
    transition: bottom 0.5s;
    &.footer-freeclass-block {
      bottom: 0;
    }
    .tips {
      padding: 10px;
      color: #fff;
      text-align: center;
      time {
        color: #ffcd88;
      }
    }
    .btn {
    
      text-align: center;
      width: 80%;
      margin: auto;
      height: 44px;
      // background: radial-gradient( 0% 0% at 0% 0%, #F5725B 0%, #5376EC 100%), #5A528D;
      // background: linear-gradient(90deg, #780947 0%, #0139d3 100%);
      border-radius: 22px;
      font-size: 16px;
      color: #fff;
      text-align: center;
      position: relative;
      line-height: 44px;

      > span {
        position: absolute;
        right: 0px;
        width: 70px;
        height: 20px;
        background: #ff3446;
        border-radius: 0px 8px 0px 8px;
        color: #ffffff;
        text-decoration: line-through;
        top: 0px;
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
  @keyframes liuguang {
    00% {
      left: -105px;
    }

    20% {
      left: -15px;
    }

    100% {
      left: 50vw;
    }
  }

  .fixed_box {
    position: fixed;
    bottom: 120px;
    width: 48px;
    right: 10px;
  }
`;

const mapStateToProps = (state) => ({
  token: state.user.accessToken,
});

export default React.memo(connect(mapStateToProps)(Active_149));



// WEBPACK FOOTER //
// ./src/views/activity_149/index.js